import { pascalCase } from 'change-case';
import { PascalCase } from '../types/utils';

export const formatByHashes = (mask: string, value: string) => {
  let i = 0;
  return mask.replace(/#/g, () => value[i++] || '');
};

export const formatPhone = (phone: string) => {
  const strToFormat = phone.replace(/\D+/g, '');
  return formatByHashes('+# (###) ###-##-##', strToFormat);
};

export const formatKeys2PascalCase = <T extends Record<string, unknown>>(
  obj: T,
): {
  [K in keyof T as K extends string ? PascalCase<K> : never]: T[K];
} => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const newObj: any = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = pascalCase(key);
      newObj[newKey] = obj[key];
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return newObj;
};
